const ROUTE_PATHS = {
    BADGES: '/badges',
    IN_PROGRESS: '/in-progress',
} as const;

export default ROUTE_PATHS;
